
const MainLayout = ({ children }: any) => {
    return (
        <div className="min-h-screen bg-[#f8f9fb] font-sans text-slate-800">
            {children}
        </div>
    )
}

export default MainLayout;